module.exports = __webpack_public_path__ + "static/icons-full-e04913230e46d48c7e6f5e36da57b055.png";